import React from "react";
import { ReactComponent as IconLogo } from "assets/icons/elite-vacances/eliteVacances.svg";
import "styles/footer.css";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footerGAC">
      <div className="footerGAC__content">
        <div className="footerGAC__logo-container">
          <IconLogo className="footerGAC__logo" />
        </div>

        <div className="footerGAC__info">
          <p className="footerGAC__legal">
            RNT N° 280829 Elite vacances SAS. NIT. 901088947-6. Oficina
            Principal Calle 93B # 19-57 oficina 302 Bogotá. Estamos
            comprometidos con: Ley 679 de 2001 y ley 1336 de 2009. Contra la
            explotación, la pornografía, el turismo sexual y otras formas de
            abuso a los menores. Decreto 2737 de 1989. Por el cual se expide el
            código del menor y en la cual está en contra de la explotación
            laboral infantil. Ley 397 de 1997. Contra el tráfico de Patrimonio
            Cultural. Ley 599 de 2000, decreto 1608 de 1978 y Ley 1453 de 2011.
            Contra el tráfico de especies como flora y fauna silvestre. Ley 1335
            de 2009. Antitabaco, por un espacio libre de humo del tabaco. Ley
            1482 de 2011. Garantizar la protección de los derechos de una
            persona, grupo de personas, comunidad o pueblo, que son vulnerados a
            tráficos de actos de racismo o discriminación. Damos cumplimiento a
            lo establecido por la Ley 1581 de 2012, sobre protección de datos
            personales.
          </p>

          <p className="footerGAC__copyright">
            © {year} | Todos los derechos reservados. Elite Vacances S.A.S
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
